















































import {TranslateResult} from 'vue-i18n';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Reconstruction} from './values';

@Component({})
export default class ReconstructionControl extends Vue {

    private get newValue(): Reconstruction | null {
        if (this.getError() !== null) {
            return null;
        }

        return {
            year: parseInt(this.year, 10),
            type: this.type,
            extent: this.extent,
            description: this.description,
        };
    }

    private get error(): TranslateResult | null {
        return this.validate
            ? this.getError()
            : null;
    }
    @Prop({type: Array, required: true})
    public readonly typeOptions: string[];

    @Prop({type: Array, required: true})
    public readonly extentOptions: string[];

    @Prop({required: true})
    public readonly value: Reconstruction | null;

    @Prop({type: Boolean, required: true})
    public readonly validate: boolean;

    public type: string = '0';
    public extent: string = '0';
    public year: string = '';
    public description: string | null = null;

    public mounted() {
        const value = this.value;

        if (value === null) {
            this.type = Object.keys(this.typeOptions)[0];
            this.extent = Object.keys(this.extentOptions)[0];
            return;
        }

        this.type = value.type;
        this.extent = value.extent;
        this.year = '' + value.year;
        this.description = value.description;
    }

    public removeReconstruction(): void {
        this.$emit('remove');
    }

    private getError(): TranslateResult | null {
        if (this.type === '0') {
            return this.$t('form.errors.reconstructions.typeNotSelected');
        }

        if (this.extent === '0') {
            return this.$t('form.errors.reconstructions.extentNotSelected');
        }

        if (this.year === '') {
            return this.$t('form.errors.reconstructions.yearNotFilled');
        }

        const year = parseInt(this.year, 10);

        if (isNaN(year)) {
            return this.$t('form.errors.reconstructions.invalidYear');
        }

        return null;
    }

    @Watch('type')
    @Watch('extent')
    @Watch('year')
    @Watch('description')
    private valueChanged(): void {
        this.$emit('input', this.newValue);
    }
}
